import classnames from 'classnames';
import type { CSSProperties, FC } from 'react';
import 'external-svg-loader';

export const FileIcon: FC<{
  className?: string;
  name: FileIcons;
  inline?: boolean;
  alt?: string;
  size?: CSSProperties['width'];
}> = (props) => {
  const mainClassName = classnames('icon', props.className);
  const iconFilePath = `/icons/${props.name}.svg`;
  const inlineIcon = props.inline;
  return (
    <span className="icon-wrapper">
      {inlineIcon && (
        <svg data-loading="lazy" width={props.size} className={mainClassName} data-src={iconFilePath}>
          <title>{props.name}</title>
        </svg>
      )}
      {!inlineIcon && (
        <img src={iconFilePath} width={props.size} className={mainClassName} alt={props.alt ?? props.name} />
      )}
    </span>
  );
};
